import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import FormControl from "@mui/material/FormControl";
import TextField from "@material-ui/core/TextField";
import { interviewStage } from "../JobInputData";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { Spinners } from "../TableOptions";
import swal from 'sweetalert';
import { reset, scheduleApplicant } from "../../features/Applicant/applicantSlice";
import moment from "moment";
import ModalHeader from "../ModalHeader";

const ScheduleModal = ({ title, name,  applicationId, id}) => {
  const dispatch = useAppDispatch();
  const { scheduleApplicantisError, scheduleApplicantmessage, scheduleApplicantisLoading, scheduleApplicantisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)




  const [inputs, setInputs] = useState({
    applicationStage: "",
    date: "",
    location: "",
    comment: "",
    applicationId: "",
  });




  const [date, setDate] = useState("");
  const [welcome, setWelcome] = useState(false);
  const handleCloseWelcome = () => setWelcome(false);
  const handleWelcome = () => setWelcome(true);


  const handleOnChange = (input: any, value: any) => {
    if (input === 'date') {
      setDate(value)
    }
    setInputs((prevState: any) => ({
      ...prevState,
      [input]: input === 'date' ? moment(value).format('DD-MM-YYYY') : value,
    }));
  };


  useEffect(() => {
    if (scheduleApplicantisError) {
      swal({
        title: "error",
        text: scheduleApplicantmessage,
        icon: "error"
      })
    } else if (scheduleApplicantisSuccess) {
      swal({
        title: "success",
        text: "Applicant have been scheduled!",
        icon: "success"
      })
      setWelcome(false)
      setInputs(
        {
          applicationStage: "",
          date: "",
          location: "",
          comment: "",
          applicationId: "",
        }
      )
    }
    dispatch(reset())
  }, [scheduleApplicantisError, scheduleApplicantisSuccess, scheduleApplicantmessage, dispatch])

  useEffect(() => {
    setInputs((prevState: any) => {
      return ({
        ...prevState,
        applicationId:  applicationId,
      });
    });
  }, [setInputs,  applicationId, inputs. applicationId]);

  const handlescheduleApplicant = () => {
    const input = { inputs, id }
    // @ts-ignore  
    dispatch(scheduleApplicant(input));
  }


  return (
    <>
      <div onClick={handleWelcome} className="more-button">
        {title}
      </div>

      <Modal show={welcome} onHide={handleCloseWelcome} centered >
        <ModalHeader setShow={setWelcome} headerTitle={"Schedule Interview"} />
        <Modal.Body>
          <form>
            <div className="applicant-name">
              <h5>Applicant Name</h5>
              <p>{name}</p>
            </div>
            <div className="schedule-setting">
              <FormControl fullWidth>
                <h5>Interview stages</h5>
                <select
                  required
                  className="round"
                  value={inputs.applicationStage}
                  onChange={(e) => handleOnChange("applicationStage", e.target.value)}
                >
                  <option>Select Stage</option>
                  {interviewStage.map((item: any, i: any) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </FormControl>
            </div>
            <div className="schedule-date">
              <h5>Date</h5>
              <TextField
                required
                id="outlined-basic"
                name="date"
                type="date"
                size="small"
                style={{ margin: "10px 0" }}
                variant="outlined"
                value={date}
                onChange={(e) => handleOnChange("date", e.target.value)}
              />
            </div>
            <div className="schedule-location">
              <h5>Location</h5>
              <TextField
                required
                id="outlined-basic"
                name="text"
                type="text"
                size="small"
                style={{ width: "100%", margin: "20px 0", borderRadius: "5px" }}
                variant="outlined"
                value={inputs.location}
                onChange={(e) => handleOnChange("location", e.target.value)}
              />
            </div>
            <div className="comment">
              <h5>Comment</h5>
              <TextField
                required
                id="outlined-multiline-static"
                multiline
                fullWidth
                type="text"
                minRows={4}
                variant="outlined"
                style={{ margin: "10px 0" }}
                value={inputs.comment}
                onChange={(e) => handleOnChange("comment", e.target.value)}
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseWelcome}>
            Cancel
          </Button>
          <Button id="primary" onClick={handlescheduleApplicant}>
            {scheduleApplicantisLoading ? <Spinners size={"sm"} /> : 'Schedule'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ScheduleModal;
